import { ChangeEvent } from "react";

import { useTranslation } from "react-i18next";

import { css } from "@emotion/react";

import { BannerType, BannerView } from "@dotnet/telematics-design-system";

import InputField, {
    INPUT_FIELD_SIZES
} from "components/DesignComponents/InputField";

import { TransferDevicesPayloadProps } from "../../types";

const TransferDevicesContent = ({
    tokenCompany,
    tokenError,
    isLoading,
    setPayload,
    clearError
}: TransferDevicesPayloadProps) => {
    const { t } = useTranslation();

    const handleInputChange = (e: ChangeEvent<HTMLInputElement>) => {
        clearError();
        setPayload(e.target.value);
    };

    return (
        <>
            {!tokenCompany ? (
                <div
                    css={css({
                        "& > div:not(:first-of-type)": {
                            marginBottom: "16px"
                        }
                    })}
                >
                    <InputField
                        data-testid="device-transfer-token-field"
                        labelLeft={t("Dialog##device transfer token")}
                        fullWidth
                        placeholder={t("General##enter here")}
                        size={INPUT_FIELD_SIZES.Medium}
                        required
                        readOnly={isLoading}
                        onChange={handleInputChange}
                        errorText={tokenError}
                    />
                </div>
            ) : (
                <div>
                    <BannerView
                        bannerType={BannerType.Warning}
                        title={t("Dialog##confirm cannot revert")}
                        css={css({
                            marginBottom: "16px"
                        })}
                    />

                    <InputField
                        labelLeft={t("Table##receiving company")}
                        fullWidth
                        readOnly
                        value={tokenCompany.company_name}
                        size={INPUT_FIELD_SIZES.Medium}
                    />
                </div>
            )}
        </>
    );
};
export default TransferDevicesContent;
